import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  fetchLogs: `${NAMESPACE}_LOCALZ_INTEGRATION_LOGS_FETCH`,
  updateLogs: `${NAMESPACE}_LOCALZ_INTEGRATION_UPDATE_LOGS`,
  setIsLoadingLogs: `${NAMESPACE}_LOCALZ_INTEGRATION_SET_IS_LOADING`,
  clearLogs: `${NAMESPACE}_LOCALZ_INTEGRATION_CLEAR_DATA`,
};

export const actionCreators = {
  fetchLogs: payload => ({ type: actions.fetchLogs, payload }),
  updateLogs: payload => ({ type: actions.updateLogs, payload }),
  setIsLoadingLogs: payload => ({ type: actions.setIsLoadingLogs, payload }),
  clearLogs: () => ({ type: actions.clearLogs }),
};

export default {
  actions,
  actionCreators,
};
